import { render } from "./opSelect.vue?vue&type=template&id=6bbc5725&scoped=true&ts=true"
import script from "./opSelect.vue?vue&type=script&lang=ts"
export * from "./opSelect.vue?vue&type=script&lang=ts"

import "./opSelect.vue?vue&type=style&index=0&id=6bbc5725&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbc5725"]])

export default __exports__